<template>
  <div>
    <!-- Alert - DESKTOP-->
    <div v-if="isTester && $route.name !== 'Chat'"
         class="row border-top-info px-4 py-1 alert-info shadow-sm mb-2"
         style="margin-left: -25px; margin-right: -25px; border-top: 1px solid rgb(120 38 31 / 20%);">
      <div class="col-12 d-flex justify-content-between pb-3 pt-4">
        <div class="d-flex align-content-center">
          <span class="pr-3 bx-sm">🎉</span>
          <span :style="($mq === 'mobile' || $mq === 'tablet') ? 'font-size: 0.9rem;' : ''">
            <strong>{{ 'Boas vindas!' }}</strong>
            Você está usando a versão de testes do nosso sistema. Essa versão oferece recursos reduzidos e tem a intenção disponibilizar apenas algumas funcionalidades para que você conheça e contrate um dos nossos planos pagos.
          </span>
        </div>
        <div class="pl-3 pt-1">
          <div style="width: 180px;"
               data-toggle="modal"
               data-target="#upgradeTesterModal"
               class="btn-sm btn btn-info py-2 shadow-none rounded-0">
            <i class="bx bxs-rocket pr-2"></i> Quero contratar!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "AlertSystemTester",
  computed: {
    ...mapState([]),
    ...mapGetters([]),
  },
  methods: {
  }
}
</script>

<style scoped>
.list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.list-group-item:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
